import { useContext } from 'react';
import { AuthDispatchContext, AuthStateContext } from 'auth/providers/AuthProvider';

export const useAuthState = () => useContext(AuthStateContext);
export const useAuthDispatch = () => useContext(AuthDispatchContext);
